import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteContaRoutingModule } from './central-cliente-conta-routing.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    CentralClienteContaRoutingModule
  ]
})
export class CentralClienteContaModule { }
